import { createAsyncThunk } from "@reduxjs/toolkit";

// GET Appointments
export const fetchAppointments = createAsyncThunk(
  "calendary/fetchAppointments",
  async (_, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.token;
      const uri = `${process.env.REACT_APP_BACKEND_URL}/calendary/appointments/`;

      const response = await fetch(uri, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Error al obtener citas");
      }

      return await response.json();
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// POST Appointment
export const createAppointment = createAsyncThunk(
  "calendary/createAppointment",
  async (appointmentData, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.token;
      const uri = `${process.env.REACT_APP_BACKEND_URL}/calendary/appointments/`;

      const response = await fetch(uri, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(appointmentData),
      });

      if (!response.ok) {
        throw new Error("Error al crear cita");
      }

      return await response.json();
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// UPDATE Appointment
export const updateAppointment = createAsyncThunk(
  "calendary/updateAppointment",
  async ({ id, appointmentData }, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.token;
      const uri = `${process.env.REACT_APP_BACKEND_URL}/calendary/appointments/${id}/`;

      const response = await fetch(uri, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(appointmentData),
      });

      if (!response.ok) {
        throw new Error("Error al actualizar cita");
      }

      return await response.json();
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// DELETE Appointment
export const deleteAppointment = createAsyncThunk(
  "calendary/deleteAppointment",
  async (id, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.token;
      const uri = `${process.env.REACT_APP_BACKEND_URL}/calendary/appointments/${id}/`;

      const response = await fetch(uri, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Error al eliminar cita");
      }

      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// GET Patients
export const fetchPatients = createAsyncThunk(
  "calendary/fetchPatients",
  async (_, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.token;
      const uri = `${process.env.REACT_APP_BACKEND_URL}/users/?role=patient`;

      const response = await fetch(uri, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("No se pudieron obtener los pacientes");
      }

      return await response.json();
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// GET Doctors
export const fetchDoctors = createAsyncThunk(
  "calendary/fetchDoctors",
  async (_, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.token;
      const uri = `${process.env.REACT_APP_BACKEND_URL}/users/?role=doctor`;

      const response = await fetch(uri, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("No se pudieron obtener los doctores");
      }

      return await response.json();
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);